import httpClient from '@/apis/base/httpclient';
import SystemApi from './_systemApi';

class LayoutApi extends SystemApi {
  controllerName = 'LayoutTemplate';

  /**
   * Lấy layout đang sử dụng
   */
  getApply(code) {
    const request = {
      url: [this.getAPIUrl(), '/', code].join(''),
    };
    return httpClient.getAsync(request);
  }

  /**
   * Load nhiều layout
   * @param {*} layouts
   * @returns
   */
  getMultipleLayout(layouts) {
    const request = {
      url: [this.getAPIUrl(), '/multiple-layout'].join(''),
      data: layouts,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy layout mặc định
   */
  getDefault(code) {
    const request = {
      url: [this.getAPIUrl(), '/default/', code].join(''),
    };
    return httpClient.getAsync(request);
  }

  /**
   * Cập nhật layout mới
   * @param {string} metaData
   * @return Promise
   */
  update(metaData, code) {
    const request = {
      url: [this.getAPIUrl(), '/', code].join(''),
      data: metaData,
    };
    return httpClient.putAsync(request);
  }

  /**
   * Lấy nhiều
   * @param {*} codes mảng các tags
   * @return Promise
   */
  getMultiple(codes) {
    const request = {
      url: [this.getAPIUrl(), '/multiple/'].join(''),
      data: codes,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Update nhiều
   */
  updateMultiple(metaData) {
    const request = {
      url: [this.getAPIUrl(), '/multiple/'].join(''),
      data: metaData,
    };
    return httpClient.putAsync(request);
  }

  /**
   * Update all layout
   */
  updateAllMultiple(metaData) {
    const request = {
      url: [this.getAPIUrl(), '/AllMultiple/'].join(''),
      data: metaData,
    };
    return httpClient.putAsync(request);
  }

  /**
   * Lấy lại layout mặc định từ system không lấy của người dùng
   * @param {*} codes mảng các tags
   * @return Promise
   * ntduong2 26.4.2024
   */
  getMultipleDefault(codes) {
    const request = {
      url: [this.getAPIUrl(), '/multiple-default/'].join(''),
      data: codes,
    };
    return httpClient.postAsync(request);
  }
}

export default new LayoutApi();
